import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Product } from '../models/product.model';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { namChatService } from '../service/namChatService';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  public products: Product[] = [];
  public isLoading = false;
  public productsChunk: Product[][] = [];

  @Input() productCart: Product[] =[];
  shopCartSideBar: any;

  totalItems = 0;
  itemsPerPage = 10;
  page?: number;
  predicate!: string;
  ascending!: boolean;
  ngbPaginationPage = 1;
  timeout!: any;
  currentSearch = '';
  showSideBar = false;
  
  @Input() set _currentSearch(value: string) {
    if (value !== null && value !== this.currentSearch) {
      this.currentSearch = value;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        
        this.loadPage(1);
      }, 750);
    }
  }
  constructor(protected productService: namChatService, 
    protected el: ElementRef) {
  }

  ngOnInit(): void {
    this.loadPage(1);
  }

  loadPage(page?: number, dontNavigate?: boolean): void {
    this.isLoading = true;
    const pageToLoad: number = page ?? this.page ?? 1;

    if (this.currentSearch) {
      this.productService
        .search({
          page: pageToLoad - 1,
          size: this.itemsPerPage,
          sort: this.sort(),
          'productProductionType.equals': 'PRODUCT'
        //  'productCode.contains': this.currentSearch
        })
        .subscribe(
          (res: HttpResponse<Product[]>) => {
            this.isLoading = false;
            this.onSuccess(res.body, res.headers, pageToLoad, !dontNavigate);
          },
          () => {
            this.isLoading = false;
            this.onError();
          }
        );
      return;
    }

    this.productService.search({
        page: pageToLoad - 1,
        size: this.itemsPerPage,
        sort: this.sort(),
        'productProductionType.equals': 'PRODUCT'
      })
      .subscribe(
        (res: HttpResponse<Product[]>) => {
          this.isLoading = false;
          this.onSuccess(res.body, res.headers, pageToLoad, !dontNavigate);
        },
        () => {
          this.isLoading = false;
          this.onError();
        }
      );
  }

  protected sort(): string[] {
    const pred = this.predicate ? this.predicate : '';
    const result = [pred + ',' + (this.ascending ? 'asc' : 'desc')];
    if (this.predicate !== 'productId') {
      result.push('productId');
    }
    return result;
  }

  protected onSuccess(data: Product[] | null, headers: HttpHeaders, page: number, navigate: boolean): void {
    
    this.totalItems = Number(headers.get('X-Total-Count'));
    this.page = page;
    this.ngbPaginationPage = this.page;
   
    this.products = data ?? [];
    this.productsChunk = this.chunk(this.products, 5);
    this.ngbPaginationPage = this.page;
  }

  protected onError(): void {
    this.ngbPaginationPage = this.page ?? 1;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public clear(): void {
    // table.clear();
  }

  

 

  protected chunk(arr: Product[], size: number): Product[][] {
    const newArr = [];
    for (let i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }

    return newArr;
  }

  toggleSideBar(){
    this.showSideBar = !this.showSideBar;
  }

  closeSideBar(){
    this.productCart = [];
    this.productCart = [...this.productCart];
    this.products.forEach(_ => _.inCart=false);
    this.productsChunk = [...this.chunk(this.products, 5)];
    
    this.toggleSideBar();
  }

 

}
